import React, { useId, useState } from "react";
import { Checkbox, Combobox, Option } from "@fluentui/react-components";
import { useReduxDispatch, useReduxSelector } from "../redux/hooks/hooks";
import { setColumns } from "../redux/slices/tabSlice";
import { userApi } from "../redux/api/userApi";
import { ISetting } from "../types/User/ISetting";
import IGridState from "../types/User/IGridState";

export const ColumnList = (): JSX.Element => {
    const dispatch = useReduxDispatch();
    const comboId = useId();
    const { groupSettings, columns } = useReduxSelector((s) => s?.tab);
    const [saveSetting] = userApi.useSaveSettingMutation();
    const options = columns || [];//["Call_Id", "Call_Desc", "Ferret", "Fish", "Hamster", "Snake"];
    //const [selected, setSelected] = useState<string[]>([]);
    const staticColumns = ["Id", "Call_Desc"];
    const visibleColumns = options?.filter(c => !c.hidden).map(c => c.title) || [];
    const columnsChanged = (newColumns: string[]) => {
        console.log("columns changed! ", newColumns);
        var newcolumnState = columns?.map(c => ({ ...c, hidden: !newColumns.includes(c.field) })) || [];
        dispatch(setColumns(newcolumnState));

        //Update the state via the API
        saveSetting({ Setting_Id: 146, Big_String_Value: JSON.stringify({ columns: newcolumnState, groups: groupSettings } as IGridState) } as ISetting).unwrap()
            .then(() => {
                console.log("Column settings saved successfully", newcolumnState, groupSettings);
            })
            .catch((error) => {
                console.error("Failed to save column settings:", error);

            })
    }

    return (
        <div className="full-screen-only">
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <Combobox appearance="underline" multiselect placeholder="Select columns..." value={visibleColumns?.length < 3 ? visibleColumns.join(", ") : `${visibleColumns?.length} columns selected`} id={comboId}
                    selectedOptions={options?.filter(c => !c.hidden).map(c => c.field)}
                    onOptionSelect={(_, data) => {
                        //setSelected(data.selectedOptions);
                        columnsChanged(data.selectedOptions);

                    }}>
                    {options.map((option) => (
                        <Option key={option.field} value={option.field} disabled={staticColumns.includes(option.field)}>
                            {option.title}
                        </Option>
                    ))}
                </Combobox>
            </div>

        </div>
    );
};